import Modal from "@mui/material/Modal";
import SupportIcon from "../Assets/Icons/SupportIcon";
import MainButton from "./Buttons/MainButton";
import ModalShell, { ModalTitle } from "./ModalShell";

function HelpModal({ title, description, open, handleClose }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalShell
        accent="info"
        icon={<SupportIcon color={"#FFFFFF"} width="38px" height="38px" />}
        onClose={handleClose}
        width="min(620px, calc(100vw - 32px))"
      >
          <ModalTitle accent="info">{title}</ModalTitle>
          <p className="mb-7 text-[16px] leading-8 text-slate-600">{description}</p>
          <div className="flex w-full justify-center">
            <MainButton onClick={handleClose} text="OK" />
          </div>
      </ModalShell>
    </Modal>
  );
}

export default HelpModal;
